import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Programming: JavaScript, TypeScript, Node JS, Express JS, Data Structure & Algorithm, Java,  JDBC, Java servlet, JSP,  React JS',
    'Databases: MySQL, MSSQL, MongoDB',
    'AWS Services: CloudFormation, Lambda, API Gateway,  S3, DynamoDB, Cognito, AWS SAM, SNS, SQS, SES, WAF, EC2, Route 53, Global Accelerator, CloudWatch, Rekognition, Comprehend, IAM, EventBridge, Systems Manager',
    'IDE & Tools: JetBrain Intellij, eclipse, VS Code, Postman, Github, Asana, Jira, Bitbucket, Stripe, Firebase, REST APIs, Agile and Scrum methodologies, Communication, Git, Linux, Web Sockets, Web Development',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! My name is Rahul Faujdar and  My work
              experience has included Javascript, Node Js, Express Js,  AWS, Java,  React Js, and other web and programming languages.
            </p>

            <p>
              Experience working as part of an agile team, including prioritizing and scoping feature requests to guarantee that the most significant features were completed first.
            </p>

            <p>
              I have experience developing full-stack web applications for analyzing and processing data as well as interacting with APIs, databases, and project managers.
            </p>

            <p>
              Ability to building new Angular components for a web app which improved the time on the page for the average.
            </p>

            <p>
              I've worked closely with the product manager, developers, and quality assurance team to determine testing methods, problems, and best practices for developing apps across various platforms.
            </p>

            <p>
              I've designed and developed multi-platform apps using the latest industry adopted technologies.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
